<script setup>
import CheckIcon from '@iconify-vue/ph/check';
import BaseCell from '@js/components/tables/cells/BaseCell.vue';
import { computed } from 'vue';

const {
    row,
    selectionIds,
    setSelectionIds,
    idKey = null,
    align = 'left',
    disabled = false,
} = defineProps({
    row: {
        type: Object,
        required: true,
    },
    selectionIds: {
        type: Array,
        required: true,
    },
    setSelectionIds: {
        type: Function,
        required: true,
    },
    idKey: {
        type: String,
        required: false,
        default: null,
    },
    align: {
        type: String,
        default: 'left',
        required: false,
    },
    disabled: {
        type: Boolean,
        default: false,
        required: false,
    },
});

const isSelected = computed(() => {
    if (idKey) {
        return selectionIds.includes(row.original[idKey]);
    } else {
        return selectionIds.includes(row.original.id);
    }
});

function select() {
    if (disabled) {
        return;
    }

    let ids = selectionIds;

    if (isSelected.value) {
        if (idKey) {
            ids = ids.filter((id) => id !== row.original[idKey]);
        } else {
            ids = ids.filter((id) => id !== row.original.id);
        }
    } else {
        if (idKey) {
            ids.push(row.original[idKey]);
        } else {
            ids.push(row.original.id);
        }
    }

    setSelectionIds(ids);
}
</script>

<template>
    <BaseCell
        :align="align"
        class="relative"
        :class="{
            'before:absolute before:right-0 before:left-0 before:h-full before:w-1 before:bg-red-500 before:content-[\'\']':
                disabled,
        }"
    >
        <button
            type="button"
            class="group inline-flex size-[25px] items-center justify-center rounded border text-white duration-150 enabled:border-indigo-900 enabled:hover:bg-indigo-600 disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100"
            :class="{
                'bg-indigo-600': isSelected && !disabled,
            }"
            :disabled="disabled"
            @click="select"
        >
            <CheckIcon
                class="size-4 text-white enabled:group-hover:visible"
                :class="{
                    visible: isSelected,
                    invisible: !isSelected,
                }"
            />
        </button>
    </BaseCell>
</template>
